import { useEffect, useRef } from 'react'

import type { Event } from '@/services/api/schemas/events'
import { ArrowLeftIcon } from '@/shared/icons'
import { EVENT_TYPE_LABELS } from '@/shared/lib/eventTypes'
import { lockBodyScroll } from '@/shared/lib/scrollLock'

import { EventDetail } from './EventDetail'
import s from './EventDetailSheet.module.css'

interface EventDetailSheetProps {
  event: Event
  onClose: () => void
}

/**
 * Детали события поверх журнала — для экранов, где две колонки не помещаются.
 * На телефоне во весь экран, на планшете — панель справа.
 */
export function EventDetailSheet({ event, onClose }: EventDetailSheetProps) {
  const backRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    const unlock = lockBodyScroll()
    backRef.current?.focus()
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKeyDown)
    return () => {
      unlock()
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [onClose])

  return (
    <div className={s.backdrop} onClick={onClose}>
      <section
        className={s.sheet}
        role="dialog"
        aria-modal="true"
        aria-label="Детали события"
        onClick={(e) => e.stopPropagation()}
      >
        <header className={s.header}>
          <button ref={backRef} type="button" className={s.back} onClick={onClose}>
            <ArrowLeftIcon size={18} />К журналу
          </button>
          <span className={s.headerTitle}>{EVENT_TYPE_LABELS[event.type]}</span>
        </header>
        <div className={s.body}>
          <EventDetail event={event} />
        </div>
      </section>
    </div>
  )
}
